import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import '@/assets/css/vue-datetimepicker.css'


export default {
  install: (app) => {
    app.component('Datepicker', Datepicker);
  }
}

